module.exports = __webpack_public_path__ + "img/generic.6c1a66d6.svg";